// src/eventBus.js
import * as bootstrap from 'bootstrap';

function showToast(message) {
    const toastElement = document.getElementById('liveToast'); // ID do elemento Toast
    if (!toastElement) {
        console.error('Elemento Toast não encontrado!');
        return;
    }

    const toastBody = document.getElementById('toastBody'); // ID do corpo do Toast
    if (toastBody) {
        toastBody.textContent = message; // Define a mensagem dinamicamente
    }

    // Inicializa o Toast usando a API do Bootstrap
    const toast = bootstrap.Toast.getOrCreateInstance(toastElement);
    toast.show();
}

export { showToast };
